import { Component } from '@angular/core';

@Component({
  selector: 'lib-arrow-right',
  imports: [],
  templateUrl: './arrow-right.html',
})
export class ArrowRightIcon {}
